import { css } from '@emotion/react';
import type { CalendarEventType, UnavailableBlockCalendarEvent } from '../../../types';

interface Props {
  event: UnavailableBlockCalendarEvent;
}
export const UnavailableBlockEvent = ({ event }: Props) => {
  return (
    <div data-event-type={'unavailableBlock' satisfies CalendarEventType} css={containerStyle}>
      {event.eventType}
    </div>
  );
};

const containerStyle = css({
  // TODO: use theme colors
  background: '#e5e7eb',
  color: '#374151',
});
